import { LanguageService } from '../language-service/language-service.js';
/**
 * Wrapper of the native {@link SpeechSynthesisUtterance} to extend its functionalities
 */
class OswaldSpeechSynthesisUtterance {
    constructor(options) {
        this.cancelled = false;
        this.speaking = false;
        // Not using `extends` because it breaks the build of the services test cases even if not used in the test
        this.synthesisUtterance = new SpeechSynthesisUtterance(options.message);
        this.synthesisUtterance.lang = LanguageService.getCurrentLanguage();
        this.synthesisUtterance.pitch = options.pitch ?? 1;
        this.synthesisUtterance.rate = options.rate ?? 1;
        this.synthesisUtterance.volume = options.volume ?? 1;
        this.synthesisUtterance.voice = options.voice ?? null;
        this.synthesisUtterance.addEventListener('start', () => {
            this.speaking = true;
        });
        this.synthesisUtterance.addEventListener('end', () => {
            this.speaking = false;
        });
        this.synthesisUtterance.addEventListener('error', () => {
            this.speaking = false;
        });
    }
    /**
     * Appends an event listener for events whose type attribute value is {@link type}.
     *
     * @param type - The type of the event to be listened.
     * @param listener - The listener callback.
     * @param options - Event listener options.
     */
    addEventListener(type, listener, options) {
        this.synthesisUtterance.addEventListener(type, listener, options);
        return () => {
            this.synthesisUtterance.removeEventListener(type, listener);
        };
    }
    /**
     * Flags this utterance as cancelled and interrupts the speaking if is being spoken.
     */
    cancel() {
        this.cancelled = true;
        if (this.speaking) {
            this.speaking = false;
            window.speechSynthesis.cancel();
        }
    }
    /**
     * Gets the original {@link SpeechSynthesisUtterance} wrapped by this class.
     */
    getUtterance() {
        return this.synthesisUtterance;
    }
    /**
     * Checks if this utterance has been cancelled.
     */
    isCancelled() {
        return this.cancelled;
    }
    /**
     * Checks if this utterance is being spoken.
     */
    isSpeaking() {
        return this.speaking;
    }
}
export { OswaldSpeechSynthesisUtterance, };
//# sourceMappingURL=speech-synthesis.js.map